import { useState, useEffect, useRef } from "react";
import {
  Grid,
  Box,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getAttributes, GetUserId } from "../../../_utilities/getUserInfo";
import * as _props from "../../../_redux/_services/JobPostingSlice";
import { customFieldsAsync } from "../../../_redux/_services/UserManagerSlice";
import NewJobpostingCard from "./New_JobpostingCard/NewJobpostingCard";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import UploadJDPanel from "../../JobPostings/PostingsTable/UploadJDPanel";
import "../../JobPostings/PostingsTable/PostingsTable.css";
import "./jobpostinglist.css";
import Searchbar from "../../../components/Searchbar/Searchbar";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import Pagination from "../../../components/DynamicTable/Pagination";
import ViewToggle from "../../../components/ViewToggle";
import { scrollToElement } from "../../../_utilities/scrollHelper";
import { GetTimeZone } from "../../../_utilities/GetTimeZone";
import WarningPopup from "../../../components/WarningPopup/WarningPopup";
import {
  resetSelectedJobPosting,
  setSelectedJobPosting,
} from "../../../_redux/SelectedJobPostingSlice";
import JobpostingDetailsTabs from "../JobpostingDetails/JobpostingDetailsTabs/JobpostingDetailsTabs";
import { warningPopups } from "../../../constants/constants";
import DynamicTable from "../../../components/DynamicTable/DynamicTable";
import { GetUserInfo } from "../../../_utilities/getUserInfo";
import Cookies from "js-cookie";
import { PostingListfloatingMenuOptions } from "../../../constants/floatingMenuConstants";
import FloatingMenu from "../../../components/FloatingMenu/FloatingMenu";

const initalState = { data: null, message: "", isloader: true };

// Table view config
const tableConfiguration = {
  isSearchbar: true,
  isPaging: true,
  isDropdownActions: false,
  isCheckbox: true,
  isActions: false,
  recordperPage: 1,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: true,
  totalRecordsCount: 0,
  totalRecordsCountText: "Total Jobs",
  limitData: 20,
  isCheckAlignRight: true,
  isPaginationTop: true,
  isSearchServer: true,
  isPagingServer: true,
  isPageRange: true,
};

const tableActionsList = { isDownload: false, isDelete: false, isClone: false };

const columnsData = [
  {
    id: 1,
    displayName: "Job Code",
    type: "Job Code",
    mappingName: "jobCode",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center",
    width: "10%",
    isEdit: true,
    nagigate: "/ats/layout/jobpostings/view",
    openNewTab: true,
  },
  {
    id: 2,
    displayName: "Job Title",
    type: "Job Code",
    mappingName: "jobTitle",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center NameCapitalise",
    width: "25%",
    isEdit: true,
    nagigate: "/ats/layout/jobpostings/view",
  },
  {
    id: 3,
    displayName: "Date and Time",
    type: "Job Code",
    mappingName: "createdAt",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center NameCapitalise",
    width: "15%",
    isEdit: true,
    nagigate: "/ats/layout/jobpostings/view",
  },
  {
    id: 4,
    displayName: "Location",
    type: "Job Code",
    mappingName: "location",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center NameCapitalise",
    width: "20%",
    isEdit: true,
    nagigate: "/ats/layout/jobpostings/view",
  },
  {
    id: 5,
    displayName: "Job Status",
    type: "Job Code",
    mappingName: "jobStatus",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center",
    width: "15%",
    isEdit: true,
    nagigate: "/ats/layout/jobpostings/view",
  },
  {
    id: 6,
    displayName: "Client",
    type: "Job Code",
    mappingName: "clientName",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center",
    width: "15%",
    isEdit: true,
    nagigate: "/ats/layout/jobpostings/view",
  },
];

/* ---------------- MAIN COMPONENT ---------------- */
const JobpostingList = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [searchQuery, setSearchQuery] = useState("");
  const [showJobDetailsById, setShowJobDetailsById] = useState(null);
  const [minimiseRightSection, setMinimiseRightSection] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showCloneConfirm, setShowCloneConfirm] = useState(false);
  const [SelectedJobIds, setSelectedJobIds] = useState([]);
  const [isResetTabs, setIsResetTabs] = useState(false);
  const [showNoData, setShowNoData] = useState(false);
  const [openJobMenu, setOpenJobMenu] = useState(false);
  const [isUploadJDPanel, setIsUploadJDPanel] = useState(false);
  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";
  const [jobpostingList, setJobpostingList] = useState([]);
  const savedView = Cookies.get("jobPostingViewPreference") || "";
  const [viewMode, setViewMode] = useState(
    location.state?.viewMode || (savedView.includes("list") || savedView === "card" ? "card" : "table"),
  );
  const [tableConfig, setTableConfig] = useState({ ...tableConfiguration });
  const [tableUsers, setTableUsers] = useState([]);
  const [finalColumns, setFinalColumns] = useState(columnsData);
  const [filterValue, setFilterValue] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    if (location.state?.viewMode) {
      setViewMode(location.state.viewMode);
    }
  }, [location.state]);
  const cardRefs = useRef({});
  const gridRef = useRef(null);

  const [config, setConfig] = useState({
    currentPage: 1,
    limit: 9,
    offset: 1,
    totalRecords: 0,
    totalRecordsCount: 0,
  });

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Ensure page is scrolled to top when navigating into this view
  // useEffect(() => {
  //   const element = document.getElementById("applicant-new");
  //   element?.scrollIntoView({ block: "start", behavior: "smooth" });
  // }, [location.pathname]);

  const showLoader = useSelector((state) => state.Loader.value);
  const { storedJobPostingId } = useSelector(
    (state) => state.SelectedJobPosting,
  );
  const showUncommonLoader = useSelector((state) => state.UncommonLoader.value);
  const recruiterList = useSelector(
    (state) => state.GetManagerTeamlead.recruiter,
  );
  const jobpostingsResponseData = useSelector(
    (state) => state.Listjobpostings.data,
  );
  const Deletejobpostingscode = useSelector(
    (state) => state.Deletejobpostings.data,
  );

  useEffect(() => {
    let timer;
    if (
      jobpostingsResponseData?.rows?.length === 0 &&
      !showLoader &&
      !showUncommonLoader
    ) {
      timer = setTimeout(() => {
        setShowNoData(true);
      }, 2000);
    } else {
      setShowNoData(false);
    }
    return () => clearTimeout(timer);
  }, [jobpostingsResponseData, showLoader, showUncommonLoader]);

  // Load initial data
  useEffect(() => {
    async function init() {
      const userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
      FetchData({ current: 1 });
      // Table view: set columns based on client preference
      let userInfo = await GetUserInfo();
      if (userInfo && userInfo.length > 0) {
        const newConfig = { ...config };
        let updatedInlineOptions = [
          ...(PostingListfloatingMenuOptions?.inline || []),
        ];
        const role = userInfo[0]?.systemroles;
        if (role !== "Manager" && role !== "Admin") {
          updatedInlineOptions = updatedInlineOptions.filter(
            (a) => a.action !== "delete",
          );
        }
        newConfig.inlineOptions = updatedInlineOptions;
        if (userInfo[0]?.clientStatus === 0) {
          let array = [...columnsData];
          const clientsIndex = array.findIndex(
            (x) => x.displayName === "Client",
          );
          if (clientsIndex !== -1) {
            array.splice(clientsIndex, 1);
          }
          setFinalColumns(array);
        }
      }
    }
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const pathnameParts = location.pathname.split("/");
    const lastSegment = pathnameParts[pathnameParts.length - 1];
    const isId = /^\d+$/.test(lastSegment);
    if (!isId) return;
    dispatch(setSelectedJobPosting({ storedJobPostingId: lastSegment }));
    const search = location.search || "";
    const timer = setTimeout(() => {
      navigate(`/ats/layout/jobpostings/list/landing${search}`, {
        replace: true,
      });
    }, 200);
    return () => clearTimeout(timer);
  }, [location.pathname, location.search, dispatch, navigate]);

  useEffect(() => {
    async function getRecruiter() {
      if (recruiterList?.length > 0) {
        const data = JSON.parse(JSON.stringify(recruiterList));
        let newArray = [];
        data.forEach((list) => {
          let obj = {
            id: list.id.toString(),
            name: `${list.firstName} ${list.lastName}`,
            emailId: list.emailId,
          };
          newArray.push(obj);
        });
      } else {
        let userId = await GetUserId();
        dispatch(_props.getManagerTeamleadAsync(" ", userId));
      }
    }
    getRecruiter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, recruiterList]);

  useEffect(() => {
    setShowJobDetailsById(storedJobPostingId);
  }, [storedJobPostingId]);

  const onReceivepropsHandler = (item, type) => {
    if (type === "view") {
      dispatch(resetSelectedJobPosting());
      setIsResetTabs(true);
      setShowJobDetailsById(item.id);
      scrollToElement("applicant-new");
      dispatch(
        setSelectedJobPosting({
          storedJobPostingId: item?.id,
          storedJobCode: item.jobCode,
        }),
      );
    } else if (type === "newTab") {
      window.open(`/ats/layout/jobpostings/view/${item.id}`, "_blank");
    }
  };

  const handleCheckboxChange = (applicant, isChecked) => {
    if (isChecked) {
      setSelectedJobIds([...SelectedJobIds, applicant]);
    } else {
      setSelectedJobIds(
        SelectedJobIds.filter((item) => item.id !== applicant.id),
      );
    }
    setJobpostingList(
      jobpostingList.map((item) =>
        item.id === applicant.id ? { ...item, isChecked } : item,
      ),
    );
  };

  const handleSearch = (query, type, page = 1) => {
    setSearchQuery(query);
    if (query !== "" && query.length >= 2 && type === "onRequestSearch") {
      let object = {
        offset: page !== 1 ? (page - 1) * config.limit + 1 : page,
        limit: config.limit,
        keyword: query,
      };
      SearchResultWithPaging(object);
    } else if (query.length < 2 && type === "onRequestSearch") {
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Required Minimum 2 Characters",
        }),
      );
    } else if (query === "") {
      let configure = { ...config, offset: 1, currentPage: 1 };
      dispatch(_props.listjobpostingsAsync(configure, "list"));
      let modifyConfig = { ...config };
      modifyConfig.currentPage = 1;
      modifyConfig.offset = 1;
      setConfig(modifyConfig);
    }
  };

  const FetchData = async (obj) => {
    setJobpostingList([]);
    if (viewMode === "table") {
      let tConfig = JSON.parse(JSON.stringify(tableConfig));
      tConfig.currentPage = obj.current;
      setTableConfig(tConfig);
      dispatch(
        _props.listjobpostingsAsync(
          {
            current: obj.current,
            offset:
              obj.current !== 1
                ? (obj.current - 1) * tableConfig.limitData + 1
                : 1,
            limit: tableConfig.limitData,
          },
          "list",
        ),
      );
    } else {
      let configure = JSON.parse(JSON.stringify(config));
      configure.currentPage = obj.current;
      configure.totalRecordsCount = 0;
      setConfig(configure);
      dispatch(_props.listjobpostingsAsync(configure, "list"));
    }
  };

  useEffect(() => {
    if (jobpostingsResponseData && jobpostingsResponseData.rows.length > 0) {
      setJobpostingList([]);
      setTableUsers([]);
      let myData = JSON.parse(JSON.stringify(jobpostingsResponseData));
      myData.rows.forEach((e) => {
        e["isChecked"] = false;
        e["createdAt"] = GetTimeZone(e.createdAt);
        if (e.primarySkills) {
          e["formattedSkills"] = e.primarySkills.split(/,|\n/);
        }
      });
      // Card config
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = myData.total_count;
      configure.totalRecordsCount = myData.total_count;
      setConfig(configure);
      // Table config
      let tConfig = JSON.parse(JSON.stringify(tableConfig));
      tConfig.totalRecords = myData.total_count / tableConfig.limitData;
      tConfig.totalRecordsCount = myData.total_count;
      setTableConfig(tConfig);
      scrollToElement("applicant-new");

      dispatch(_props.listjobpostingsStartReducer(initalState));
      setJobpostingList(myData.rows);
      setTableUsers(myData.rows);
    } else if (jobpostingsResponseData || jobpostingsResponseData?.rows) {
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecordsCount = 0;
      configure.totalRecords = 0;
      configure.currentPage = 1;
      setConfig(configure);
      let tConfig = JSON.parse(JSON.stringify(tableConfig));
      tConfig.totalRecordsCount = 0;
      tConfig.totalRecords = 0;
      tConfig.currentPage = 1;
      setTableConfig(tConfig);
    }
  }, [jobpostingsResponseData]);

  const SearchResultWithPaging = async (object) => {
    let configure = JSON.parse(JSON.stringify(config));
    configure.currentPage = object.current;
    setConfig(configure);
    setJobpostingList([]);
    dispatch(_props.listjobpostingsAsync(object, "searchWithPaging"));
  };

  const DeleteRecords = async (object) => {
    let ids;
    if (typeof object === "object" && object.length > 0) {
      ids = object.map((x) => x.id.toString());
    } else {
      ids = [object.toString()];
    }
    let obj = { ids: ids };
    dispatch(_props.deletejobpostingsAsync(obj));
  };

  useEffect(() => {
    if (Deletejobpostingscode === 200) {
      setSearchQuery("");
      setFilterValue("");
      dispatch(_props.deletejobpostingsStartReducer(initalState));
      if (viewMode === "table") {
        let obj1 = {
          current: tableConfig.currentPage || 1,
          offset: (tableConfig.currentPage && tableConfig.currentPage !== 1) ? (tableConfig.currentPage - 1) * tableConfig.limitData + 1 : 1,
          limit: tableConfig.limitData,
        };
        setTableUsers([]);
        dispatch(_props.listjobpostingsAsync(obj1, "list"));
      } else {
        let obj1 = {
          current: config.currentPage,
          offset:
            config.currentPage !== 1
              ? (config.currentPage - 1) * config.limit + 1
              : config.currentPage,
        };
        FetchData(obj1);
      }
    }
  }, [Deletejobpostingscode, viewMode, tableConfig.currentPage, tableConfig.limitData, config.currentPage, config.limit]);

  const handleActionClick = (obj) => {
    const modifyConfig = { ...config };
    modifyConfig.currentPage = obj;
    modifyConfig.offset = obj !== 1 ? (obj - 1) * config.limit + 1 : 1;
    if (searchQuery !== "") {
      handleSearch(searchQuery, "onRequestSearch", obj);
    } else {
      dispatch(_props.listjobpostingsAsync(modifyConfig, "list"));
    }
    setConfig(modifyConfig);
    scrollToElement("applicant-new");
  };

  const handleConfirmDelete = async () => {
    setShowDeleteConfirm(false);
    if (SelectedJobIds.length > 0) {
      if (SelectedJobIds.length === jobpostingList.length && (config.currentPage > 1 || tableConfig.currentPage > 1)) {
        let modifyConfig = { ...config };
        let modifyTableConfig = { ...tableConfig };
        if (viewMode === "card") {
          modifyConfig.currentPage = config.currentPage - 1;
          modifyConfig.offset = (modifyConfig.currentPage - 1) * config.limit + 1;
          setConfig(modifyConfig);
        } else {
          modifyTableConfig.currentPage = tableConfig.currentPage - 1;
          modifyTableConfig.offset = (modifyTableConfig.currentPage - 1) * tableConfig.limitData + 1;
          setTableConfig(modifyTableConfig);
        }
      }
      DeleteRecords(SelectedJobIds);
      setSelectedJobIds([]);
    }
  };

  const handleConfirmClone = async () => {
    setShowCloneConfirm(false);
    if (SelectedJobIds.length > 0) {
      // clone jobdetails
      await dispatch(_props.jobpostingsbyidAsync(SelectedJobIds[0].id));
      // clone screening questions
      let getUserDetails = await getAttributes();
      const customHeaders = {
        jobCode: SelectedJobIds[0].jobCode,
        userId: getUserDetails[0].userId,
      };
      await dispatch(
        _props.getListofQuestionsAsync(SelectedJobIds[0].id, customHeaders),
      );
      navigate("/ats/layout/jobpostings/create/jobdetails");
      setSelectedJobIds([]);
    }
  };

  const handleViewChange = (newView) => {
    setViewMode(newView);
    setSelectedJobIds([]);
    setSearchQuery("");
    setFilterValue("");
    // Reset to page 1 when switching views
    if (newView === "card") {
      let configure = { ...config, currentPage: 1, offset: 1, limit: config.limit };
      setConfig(configure);
      dispatch(_props.listjobpostingsAsync(configure, "list"));
    } else {
      let configure = { ...tableConfig, currentPage: 1, offset: 1, limitData: tableConfig.limitData };
      setTableConfig(configure);
      let obj = { offset: 1, limit: tableConfig.limitData };
      dispatch(_props.listjobpostingsAsync(obj, "list"));
    }
  };

  // Table view action handler (pagination, search, delete, clone)
  const onReceiveTableActionHandler = async (type, object) => {
    if (type === "confirmDel") {
      if (object.length === tableUsers.length && tableConfig.currentPage > 1) {
        let tConfig = { ...tableConfig };
        tConfig.currentPage = tableConfig.currentPage - 1;
        tConfig.offset = (tConfig.currentPage - 1) * tableConfig.limitData + 1;
        setTableConfig(tConfig);
      }
      DeleteRecords(object);
    } else if (type === "pagination") {
      let tConfig = JSON.parse(JSON.stringify(tableConfig));
      tConfig.currentPage = object.current;
      setTableConfig(tConfig);
      if (filterValue !== "") {
        let obj = { ...object, keyword: filterValue };
        dispatch(_props.listjobpostingsAsync(obj, "searchWithPaging"));
      } else {
        setTableUsers([]);
        dispatch(_props.listjobpostingsAsync(object, "list"));
      }
    } else if (type === "searchResult") {
      setFilterValue(object.keyword);
      setTableUsers([]);
      let obj = {
        keyword: object.keyword,
        offset: 1,
        limit: tableConfig.limitData,
      };
      dispatch(_props.listjobpostingsAsync(obj, "searchWithPaging"));
    } else if (type === "cancelSearchResult") {
      setFilterValue("");
      setTableUsers([]);
      setTableConfig({ ...tableConfig, currentPage: 1 });
      let obj = { current: 1, offset: 1, limit: tableConfig.limitData };
      dispatch(_props.listjobpostingsAsync(obj, "list"));
    } else if (type === "pageRange") {
      setTableConfig({ ...tableConfig, limitData: object });
      let obj = { current: 1, offset: 1, limit: object };
      if (filterValue !== "") {
        obj.keyword = filterValue;
        dispatch(_props.listjobpostingsAsync(obj, "searchWithPaging"));
      } else {
        dispatch(_props.listjobpostingsAsync(obj, "list"));
      }
    } else if (type === "confirmClone") {
      await dispatch(_props.jobpostingsbyidAsync(object[0].id));
      let getUserDetails = await getAttributes();
      const customHeaders = {
        jobCode: object[0].jobCode,
        userId: getUserDetails[0].userId,
      };
      await dispatch(
        _props.getListofQuestionsAsync(object[0].id, customHeaders),
      );
      navigate("/ats/layout/jobpostings/create/jobdetails");
    } else if (type === "selectedRows") {
      setSelectedJobIds(object);
    } else if (type === "detailspage") {
      // navigate(`/ats/layout/jobpostings/view/${object.id}`);
    }
  };

  const onSelectChangeHandler = (type, isBoolean) => {
    if (type === "delete") {
      if (SelectedJobIds.length === 0) {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Please select at least one job to delete.",
          }),
        );
        return;
      } else {
        setShowDeleteConfirm(true);
      }
    } else if (type === "clone") {
      if (SelectedJobIds.length === 0) {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Please select at least one job to clone.",
          }),
        );
        return;
      } else if (SelectedJobIds.length > 1) {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Please select only one job to clone.",
          }),
        );
        return;
      } else {
        setShowCloneConfirm(true);
      }
    } else if (type === "uploadJd") {
      setOpenJobMenu(false);
      setIsUploadJDPanel(true);
    } else if (type === "createManually") {
      setOpenJobMenu(false);
      navigate("/ats/layout/jobpostings/create/jobdetails");
    }
  };

  const onReceivePropsHandler = (_status, type) => {
    if (type === "close" || _status === "close") {
      if (isUploadJDPanel) {
        setIsUploadJDPanel(false);
        setOpenJobMenu(false);
      } else {
        setShowJobDetailsById(null);
        setMinimiseRightSection(false);
        dispatch(resetSelectedJobPosting());
        dispatch(_props.jobpostingsbyidStartReducer({}));
      }
    } else if (type === "reload" || _status === "reload") {
      let configure = { ...config, currentPage: 1 };
      dispatch(_props.listjobpostingsAsync(configure, "list"));
    } else if (type === "changeAppliant" || _status === "changeAppliant") {
      setIsResetTabs(false);
    }
  };

  useEffect(() => {
    const isCardInCurrentList = jobpostingList?.some(
      (item) => item.id === showJobDetailsById,
    );
    if (
      showJobDetailsById &&
      isCardInCurrentList &&
      cardRefs.current[showJobDetailsById]
    ) {
      cardRefs.current[showJobDetailsById].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (gridRef.current) {
      gridRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [showJobDetailsById, jobpostingList]);

  /* ---------------- JSX ---------------- */
  return (
    <div id="applicant-new">
      <div style={{ marginTop: isMobile ? "56px" : "80px" }}>
        <div
          style={{
            background: "#fff",
            padding: isMobile ? "12px 12px 60px" : "22px 47px 47px",
            minHeight: isMobile ? "calc(100vh - 80px)" : "calc(100vh - 150px)",
          }}
        >
          {/* HEADER WITH SEARCH, ADD BUTTON, AND ADVANCED SEARCH - ALL IN ONE LINE */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div style={{ display: "block", width: "9%" }}></div>
            {/* SEARCH FIELD - CENTER (card view only; table view uses DynamicTable's built-in search) */}
            {showJobDetailsById === null && viewMode === "card" && (
              <Searchbar
                value={searchQuery}
                placeholder="Search By Job Code, Job Title, Location"
                onChange={(value) => handleSearch(value, "onChange")}
                onEnter={(value) => {
                  let modifyConfig = { ...config };
                  modifyConfig.currentPage = 1;
                  setConfig(modifyConfig);
                  handleSearch(value, "onRequestSearch");
                }}
                onClear={() => handleSearch("", "onCancelSearch")}
              />
            )}
            {showJobDetailsById === null && viewMode === "card" && (
              <FloatingMenu
                config={config}
                floatingMenuOptions={{
                  ...PostingListfloatingMenuOptions,
                  inline: PostingListfloatingMenuOptions.inline.filter(
                    (opt) =>
                      opt.action !== "delete" ||
                      GetUserInfo()?.[0]?.systemroles === "Admin" ||
                      GetUserInfo()?.[0]?.systemroles === "Manager"
                  ),
                }}
                onReceiveActionHandler={onSelectChangeHandler}
                storedTheme={storedTheme}
              />
            )}
          </Box>
          {showJobDetailsById !== null && (
            <img
             src={!minimiseRightSection ? process.env.PUBLIC_URL +
                "/assests/img/advance-search-minimise.svg" : process.env.PUBLIC_URL +
                "/assests/img/minimise.svg"
              }
              alt=""
              className="advance-search-minimise"
              style={{
                left: minimiseRightSection ? "52px" : "25.5%",
                // marginTop: minimiseRightSection ? "-42px" : "-45px",
              }}
              onClick={(e) => {
                setMinimiseRightSection(!minimiseRightSection);
              }}
            />
          )}
          {/* MAIN LAYOUT */}
          {viewMode === "table" && showJobDetailsById === null && (
            <>
              <div className="aligned-floating-menu">
                <FloatingMenu
                  config={config}
                  floatingMenuOptions={{
                        ...PostingListfloatingMenuOptions,
                        inline: PostingListfloatingMenuOptions.inline.filter(
                          (opt) =>
                            opt.action !== "delete" ||
                            GetUserInfo()?.[0]?.systemroles === "Admin" ||
                            GetUserInfo()?.[0]?.systemroles === "Manager"
                        ),
                      }}
                  onReceiveActionHandler={onSelectChangeHandler}
                  storedTheme={storedTheme}
                />
              </div>
              <div id="postings-table-view" style={{ position: "relative" }}>
                <DynamicTable
                  config={tableConfig}
                  data={tableUsers}
                  colmns={finalColumns}
                  actionDropdown={[]}
                  actions={{}}
                  filterValue={filterValue}
                  noDataText={"No Postings Found"}
                  addModel={{}}
                  searchKeyWord="Search by Job Code, Job Title, Location, Client Name"
                  onReceiveActionProps={(type, obj) =>
                    onReceiveTableActionHandler(type, obj)
                  }
                />
              </div>
            </>
          )}

          {viewMode === "card" && (
            <>
              {showJobDetailsById === null && (
                <span>
                  <b>Total Jobs </b>
                  <span key={config.totalRecordsCount}>
                    - {config.totalRecordsCount}
                  </span>
                </span>
              )}
              <div
                className="d-flex"
                style={{
                  marginTop: showJobDetailsById !== null ? "34px" : "20px",
                }}
              >
                {/* RIGHT SIDE – CARDS */}
                <div
                  className={
                    showJobDetailsById !== null ? "cards-sidebar-wrapper" : ""
                  }
                  style={{
                    width:
                      showJobDetailsById === null
                        ? "100%"
                        : minimiseRightSection
                          ? "0"
                          : "27%",
                    position: "relative",
                  }}
                >
                  <div
                    className={
                      showJobDetailsById !== null
                        ? "rightside-cards-section"
                        : ""
                    }
                    style={{ display: minimiseRightSection ? "none" : "block" }}
                  >
                    <Grid
                      container
                      spacing={3}
                      ref={gridRef}
                      style={{
                        minHeight: "calc(100vh - 250px)",
                        height:
                          config.totalRecords < 9 && showJobDetailsById !== null
                            ? "calc(100vh - 163px)"
                            : "",
                      }}
                    >
                      {jobpostingList && jobpostingList?.length > 0
                        ? jobpostingList.map((item, index) => {
                            const isViewDetails =
                              showJobDetailsById === null ? false : true;
                            return (
                              <Grid
                                item
                                xs={12}
                                sm={isViewDetails ? 12 : 6}
                                md={isViewDetails ? 12 : 4}
                                key={index}
                                ref={(el) => {
                                  if (el) cardRefs.current[item.id] = el;
                                }}
                              >
                                <NewJobpostingCard
                                  data={item}
                                  selectedCard={showJobDetailsById}
                                  onEventHandler={(type) =>
                                    onReceivepropsHandler(item, type)
                                  }
                                  onCheckboxChange={handleCheckboxChange}
                                />
                              </Grid>
                            );
                          })
                        : showNoData && (
                            <Box
                              sx={{
                                width: "100%",
                                padding: "20px",
                                textAlign: "center",
                              }}
                            >
                            <div className="detail-card-empty no-data-card">
                              <img
                                src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                                alt="No data"
                              />
                              No Postings Found
                            </div>
                            </Box>
                          )}
                    </Grid>
                    <div
                      className="applicant-list-count"
                      style={{
                        paddingTop: showJobDetailsById === null ? "7px" : "",
                        justifyContent:
                          showJobDetailsById === null ? "space-between" : "end",
                        marginTop: showJobDetailsById === null ? "" : "0px",
                        marginRight: showJobDetailsById === null ? "" : "0px",
                      }}
                    >
                      {showJobDetailsById === null && (
                        <h4
                          style={{
                            position:
                              jobpostingList?.length === 0 ? "absolute" : "",
                            bottom: jobpostingList?.length === 0 ? "-43px" : "",
                          }}
                        ></h4>
                      )}
                      <Pagination
                        currentPage={config.currentPage}
                        totalCount={config.totalRecords}
                        pageSize={config.limit}
                        onPageChange={(page) => handleActionClick(page)}
                      />
                    </div>
                  </div>
                </div>
                {/* VIEW COMPONENT */}
                {showJobDetailsById !== null && (
                  <div
                    className="applicant-detail-view-wrapper"
                    style={{
                      width: minimiseRightSection ? "100%" : "73%",
                      marginLeft: isMobile ? "0" : "20px",
                      marginTop: minimiseRightSection
                        ? "-20px"
                        : isMobile
                          ? "0"
                          : "-50px",
                    }}
                  >
                    <JobpostingDetailsTabs
                      onResetTabs={isResetTabs}
                      onReceiveProps={(type) => {
                        onReceivePropsHandler(type);
                      }}
                    />
                  </div>
                )}
              </div>
            </>
          )}

          {/* View Toggle — shared for both views */}
          {showJobDetailsById === null && (
            <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                marginBottom: "-20px",
              }}
            >
              <ViewToggle
                view={viewMode}
                type={"jobposting"}
                onChange={handleViewChange}
              />
            </div>
          )}
        </div>
      </div>
      {/* DELETE CONFIRMATION DIALOG */}
      <WarningPopup
        dialogTitle={'Confirm Deletion'}
        open={showDeleteConfirm}
        handleClose={() => setShowDeleteConfirm(false)}
        handleConfirm={handleConfirmDelete}
        details={warningPopups.DELETE_POPUP}
      />
      {/* CLONE CONFIRMATION DIALOG */}
      <WarningPopup
        open={showCloneConfirm}
        handleClose={() => setShowCloneConfirm(false)}
        handleConfirm={handleConfirmClone}
        details={warningPopups.CLONE_POPUP}
      />
      {isUploadJDPanel && (
        <div className="postings-upload-panel">
          <RightSideBar
            componentData={
              <UploadJDPanel onReceivechildProps={onReceivePropsHandler} />
            }
            componentLayout={{
              title: "Upload Job Description",
              description: "",
              pageName: "jobpostings",
            }}
            isFooter={false}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      )}
    </div>
  );
};
export default JobpostingList;
